import { render, staticRenderFns } from "./prescription-list-table.vue?vue&type=template&id=72048533&scoped=true&"
import script from "./prescription-list-table.vue?vue&type=script&lang=js&"
export * from "./prescription-list-table.vue?vue&type=script&lang=js&"
import style0 from "./prescription-list-table.vue?vue&type=style&index=0&id=72048533&lang=scss&scoped=true&"
import style1 from "./prescription-list-table.vue?vue&type=style&index=1&id=72048533&lang=scss&scoped=true&"
import style2 from "./prescription-list-table.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72048533",
  null
  
)

export default component.exports
import {QTable,QInnerLoading,QSpinnerIos,QInput,QIcon,QBtn,QTooltip,QTr,QTh,QTd,QCard,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QInnerLoading,QSpinnerIos,QInput,QIcon,QBtn,QTooltip,QTr,QTh,QTd,QCard,QImg})
